var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "city-search" },
    [
      _c("h3", [_vm._v("\n    Выбор региона доставки\n  ")]),
      _c("ui-input", {
        attrs: {
          name: "query",
          autocomplete: "off",
          placeholder: "Введите название города",
          clearable: ""
        },
        on: {
          input: function($event) {
            _vm.query.length > 1 ? _vm.sendQuery(_vm.query) : null
          }
        },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      }),
      _vm.suggests.length && _vm.query.length > 1
        ? _c(
            "div",
            { staticClass: "suggests" },
            _vm._l(_vm.suggests, function(city) {
              return _c(
                "div",
                {
                  key: city.id,
                  on: {
                    click: function($event) {
                      return _vm.chooseCity(city)
                    }
                  }
                },
                [
                  _vm._v("\n      " + _vm._s(city.name) + "\n      "),
                  _c("span", [
                    _vm._v(
                      _vm._s(city.region.name) + " " + _vm._s(city.region.kind)
                    )
                  ])
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "popular" }, [
            _c("span", [_vm._v("Популярные города")]),
            _vm.popularCities.length
              ? _c(
                  "div",
                  { staticClass: "lists" },
                  _vm._l(_vm.popularCities, function(city) {
                    return _c(
                      "div",
                      {
                        key: city.id,
                        staticClass: "lists__item",
                        on: {
                          click: function($event) {
                            return _vm.chooseCity(city)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(city.name) + "\n      ")]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticClass: "popular-loader" },
                  [_c("ui-loader", { attrs: { size: "60" } })],
                  1
                )
          ]),
      _vm.isLoading && !this.$city.isConfirmationNeeded
        ? _c(
            "div",
            { staticClass: "main-loader" },
            [_c("ui-loader", { attrs: { size: "60" } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }